import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { FoldersService } from '../services/folders.service';
import { FoldersResponse } from '../interfaces/folders-response.interface';
import { CollectionItem } from '../interfaces/collection-item.interface';

export const FoldersResolver: ResolveFn<FoldersResponse<CollectionItem>> = (): Observable<FoldersResponse<CollectionItem>> => {
  const foldersService = inject(FoldersService);

  return foldersService.get();
};
